// @ts-check
import React, { Component } from "react";
import Modal from "ReactComponents/Modal/modal";
import { profileComposer } from "ReactReducers/Profile/profile-composer";
import { trialLicenseComposer } from "ReactReducers/TrialLicense/trial-license-composer";
import { basketComposer } from "ReactReducers/Basket/basket-composer";
import TrialLicenseMediaTypeList from "./TrialLicenseMediaTypeList/trial-license-media-type-list";
import ModalSpinner from "ReactComponents/Modal/modal-spinner";
import ProductMediaLinkWithCallback from "ReactComponents/ProductPage/ProductMediaLink/product-media-link-with-callback";
import IconBookOpen from "ReactComponents/Shared/Icons/icon-book-open";
import IconEmail from "ReactComponents/Shared/Icons/icon-email";

class TrialLicenseLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            isAdding: false
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.validateLicense = this.validateLicense.bind(this);
        this.onClick = this.onClick.bind(this);
        this.addToBasket = this.addToBasket.bind(this);
        this.renderTrialLicense = this.renderTrialLicense.bind(this);
    }

    toggleModal(value) {
        let val = this.state.modalOpen;
        if (value != undefined) {
            val = value;
        }
        this.setState({
            modalOpen: val
        });
    }

    // isLoading() {
    //     if (this.props.TrialLicense.TrialLicenseProductIsbn) {
    //         const isAdding =
    //             this.props.isAdding.indexOf(this.props.TrialLicense.TrialLicenseProductIsbn) != -1;
    //         const isAdding2 = this.props.isAdding.indexOf(this.props.product.Isbn13) != -1;

    //         console.log("this.props.isAdding", isAdding);
    //         console.log("this.props.isAdding2", isAdding2);

    //         return isAdding || isAdding2;
    //     }
    // }

    validateLicense() {
        if (this.props.TrialLicense.IsUserPermitted) {
            const isbn = this.props.TrialLicense.TrialLicenseProductIsbn;
            this.props.trialLicenseValidate({ isbn });
        } else this.toggleModal(true);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isAdding.length > this.props.isAdding.length) {
            // console.log("Added to basket OR something went wrong");
            this.setState({ isAdding: false });
            this.setState({ modalOpen: false });
        }

        if (
            (!prevProps.trialLicenseValidateSuccess && this.props.trialLicenseValidateSuccess) ||
            (!prevProps.trialLicenseRequestSuccess && this.props.trialLicenseRequestSuccess) ||
            (!prevProps.trialLicenseError && this.props.trialLicenseError)
        ) {
            this.toggleModal(true);
        }
    }

    addToBasket(payload) {
        this.setState({ isAdding: true });
        const basketItem = {
            Id: payload.Product.Id,
            amount: 1,
            product: payload.Product,
            BasketLineType: payload.IsPhysical ? "TeacherCopies" : "Trial",
            PeriodUnitTypeCode: payload.Product.TrialAccess?.PeriodUnitTypeCode,
            PeriodUnitValue: payload.Product.TrialAccess?.PeriodUnitValue,
            SalesFormCode: payload.Product.TrialAccess?.SalesFormCode,
            AccessFormCode: payload.Product.TrialAccess?.AccessFormCode
        };
        this.props.add(basketItem);
    }

    onClick(payload) {
        this.addToBasket(payload);
    }

    render() {
        const trialLicense = this.props.TrialLicense;
        const createProfileUrl = this.props.createProfileUrl || {};
        const productTitle = this.props.product?.Title ?? "";
        const siteName = this.props.siteName ?? "";
        const leadText = trialLicense.OrderViaEmail?.LeadText ?? "";
        const email = trialLicense.OrderViaEmail?.Email ?? "";
        const buttonText = trialLicense.OrderViaEmail?.ButtonText ?? "";

        if (!this.props.loggedIn) {
            return (
                <>
                    <ProductMediaLinkWithCallback
                        icon={<IconBookOpen />}
                        label={trialLicense.OrderTrialAccessText}
                        onClick={() => this.toggleModal(true)}
                    />
                    <Modal
                        isOpen={this.state.modalOpen}
                        toClose={() => {
                            this.toggleModal(false);
                        }}
                        showCloseButton
                        labelledBy="trial-license-modal-title"
                    >
                        <div
                            className="content--white article-content"
                            style={{
                                maxWidth: "400px",
                                margin: "auto"
                            }}
                        >
                            <div
                                id="trial-license-modal-title"
                                className="content--push-bottom"
                                dangerouslySetInnerHTML={{ __html: trialLicense.LoginIntroText }}
                            ></div>
                            <p className="u-text-align-center">
                                <button
                                    type="button"
                                    onClick={this.props.userLogin}
                                    className="button button--slim button--wide"
                                >
                                    {trialLicense.LoginButtonText}
                                </button>
                            </p>
                            <p className="u-text-align-center">
                                <a
                                    href={createProfileUrl.Url}
                                    className="button-hollow button--slim button--wide"
                                >
                                    {trialLicense.CreateProfileButtonText}
                                </a>
                            </p>

                            {siteName === "Gu" && email && leadText && buttonText && (
                                <>
                                    <p className="u-text-align-center">{leadText}</p>
                                    <a
                                        href={`mailto:${email}?subject=Bestilling%20af%20prøveadgang%20til:%20${productTitle}%20-%20${trialLicense.TrialLicenseProductIsbn}&body=Skriv%20din%20kontaktinfo%20her%0D%0ANavn:%0D%0AEmail:%0D%0ATlf.%20nr.:%0D%0AStilling:%0D%0ASkolenavn:%0D%0AInstitutionsnummer:%0D%0AKommune:`}
                                        className="button-hollow button--slim button--wide button--flex button--has-icon"
                                    >
                                        <IconEmail />
                                        {buttonText}
                                    </a>
                                </>
                            )}
                        </div>
                    </Modal>
                </>
            );
        }

        return (
            <>
                <ProductMediaLinkWithCallback
                    icon={<IconBookOpen />}
                    label={trialLicense.OrderTrialAccessText}
                    onClick={this.validateLicense}
                />
                <div>
                    <ModalSpinner isOpen={this.props.trialLicensePending && !this.props.trialLicenseError} />
                    {this.renderTrialLicense(trialLicense, this.props.trialLicenseErrorMessage)}
                </div>
            </>
        );
    }

    renderTrialLicense(trialLicense, errorMessage) {
        if (errorMessage) {
            return (
                <Modal
                    isOpen={this.state.modalOpen}
                    toClose={() => {
                        this.toggleModal(false);
                    }}
                    showCloseButton
                    labelledBy="trial-license-modal-error-title"
                >
                    <div
                        id="trial-license-modal-error-title"
                        className="content--white article-content"
                        dangerouslySetInnerHTML={{ __html: errorMessage }}
                    />
                </Modal>
            );
        }

        return trialLicense.IsUserPermitted ? (
            <Modal
                isOpen={this.state.modalOpen}
                toClose={() => {
                    this.toggleModal(false);
                }}
                showCloseButton
            >
                <div className="content--white article-content">
                    <TrialLicenseMediaTypeList
                        trialLicenseProducts={this.props.trialLicenseStatus.TrialLicenseProducts}
                        trialLicenseOrdered={this.props.trialLicenseStatus.TrialLicenseOrdered}
                        onClick={this.onClick}
                        isLoading={this.state.isAdding}
                    />
                </div>
            </Modal>
        ) : (
            <Modal
                isOpen={this.state.modalOpen}
                toClose={() => {
                    this.toggleModal(false);
                }}
                showCloseButton
                labelledBy="trial-license-modal-invalid-permission-title"
            >
                <div className="content--white article-content">
                    <div
                        id="trial-license-modal-invalid-permission-title"
                        className="content-rich-text"
                        dangerouslySetInnerHTML={{
                            __html: trialLicense.InvalidPermissionText
                        }}
                    />
                </div>
            </Modal>
        );
    }
}

export default basketComposer(trialLicenseComposer(profileComposer(TrialLicenseLink)));
